import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';

export const StyledFooter = styled.section`
    padding: 0;
    background: #F8F8F8;
    position: relative;
    overflow: hidden;
    z-index: 0;
    min-height: 100vh;

    .partner-logo {
        gap: 10px;
        margin-top: 30px;
		width: 100%;
        .single-box {
            width: calc(50% - 10px);
            min-height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 calc(50% - 10px);
            background-color: white;

			img{
				height: 90px;
			}
            &.single-box-content {
                background-color: #9f9f9f;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                padding: 15px;

                p {
					font-size: 1.1rem;
                    color: white;
                }
            }
        }
		
		@media(max-width: 767px){
			.single-box{
			}
		}
    }
	.partner-logo-yo{
		margin-top: 15px;
		img{
			height: 25px;
		}
	}

    .fixed-left {
        position: absolute;
        left: 0;
        bottom: 130px;
        z-index: 0 !important;

    }

    .fixed-right {
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 0;
    }

    .fixed-bg-wrapper {
        position: relative;

        &.paddingAdd {
            padding-top: 120px;
        }

        img, svg {
            width: 100%;
            height: 100%;
        }


    }

    .top-fixed-footer {
        position: relative;
        left: 0;
        right: 0;
        top: -200px;

        svg {
            width: 100%;
        }
    }

    .footer-wrapper {
        background: ${theme.colors.primary};
        padding: 120px 0 30px;

        .footer_menu {
            ul {
                li {
                    margin-bottom: 10px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    a {
                        font-weight: 500;
                        font-size: 1.25rem; /* 20px converted to rem */
                        line-height: 1.5rem; /* 24px converted to rem */
                        letter-spacing: 0; /* No letter spacing */
                    }
                }
            }
        }

        .footer_address {
            .dc-btn-link {
                display: block;
            }

            .address {
                margin-top: 30px;


                a {
                    font-weight: 500;


                }

                @media (min-width: 1336px) {
                    max-width: 55%;
                }
            }

            .email {
                margin-bottom: 5px;
            }

            a {
                font-weight: 500;
                font-size: 1.25rem; /* 20px converted to rem */
                line-height: 1.5rem; /* 24px converted to rem */
                letter-spacing: 0; /* No letter spacing */
                margin-bottom: 0;

            }
        }

    }

    .container-copy-right {
        padding-top: 120px;
        padding-bottom: 30px;
        position: relative;

        p {
            color: rgba(255, 255, 255, 0.5);
            font-weight: 500;
            font-size: 1rem; /* 16px converted to rem */
            line-height: 1.25rem; /* 20px converted to rem */
            letter-spacing: 0; /* No letter spacing */
        }

        a {
            p {
                transition: ${theme.transition};
            }

            &:hover {
                color: ${theme.colors.hover};

                p {
                    color: ${theme.colors.hover};
                }
            }

        }
    }

    .last-container {
        .last-container_column {
            position: relative;
            padding-top: 30px;

            &:after {
                content: "";
                width: calc(100% - 15px);
                height: 1px;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                margin: 0 auto;
                background: rgba(255, 255, 255, 0.5);
            }

        }

        ul {
            display: flex;
            gap: 30px;

            li {
                a {
                    font-weight: 500;
                    font-size: 1rem; /* 16px converted to rem */
                    line-height: 1.25rem; /* 20px converted to rem */
                    letter-spacing: 0; /* No letter spacing */
                    color: white;
                    text-decoration: underline;
                    text-decoration-style: solid;
                    text-decoration-offset: 0px; /* No extra spacing */
                    text-decoration-thickness: 0px; /* No visible underline */
                    text-decoration-skip-ink: auto;
                }
            }
        }
    }


    @media (max-width: 767px) {
        .footer-wrapper {
            .footer-fav-logo {
                margin-bottom: 40px;

                img {
                    height: 165px;
                }
            }

            .footer_first {
                .footer_logo {
                    order: 0;
                }

                .footer_address {
                    order: 1;
                }

                .footer-social {
                    margin: 30px 0 60px;
                    order: 2;
                    justify-content: flex-start !important;
                }

                .footer_menu {
                    order: 3;
                }
            }

            .container-copy-right {
                padding-top: 60px;
                padding-bottom: 60px;

                .d-inline-flex.gap-2 {
                    margin-top: 30px;
                }
            }

            .last-container {
                ul {
                    flex-direction: column;
                    gap: 20px;

                    li {
                        margin: 0;

                        a {
                            margin: 0;
                        }
                    }
                }
            }
        }

        .floating-image-left {
            bottom: unset;
            top: 0;

            svg {
                width: 100%;
                height: auto;

                &:first-child {
                    display: none;
                }

                &:last-child {
                    display: block;
                }
            }
        }

        .floating-image-right {
            svg {
                width: 100%;
                height: auto;
            }
        }

    }

`;
